<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  name: { type: String, required: false, default: null },
  subtitle: { type: String, required: false, default: null },
  isParent: { type: Boolean, required: true },
  isOpen: { type: Boolean, required: false, default: false },
  isChild: { type: Boolean, required: false, default: false },
  showAddButton: { type: Boolean, required: false, default: true },
  showEditButton: { type: Boolean, required: false, default: true },
  parentIcon: { type: Object, required: false, default: () => ({ open: 'fal fa-folder-open', close: 'fal fa-folder' }) },
});

const emits = defineEmits(['add', 'edit']);

const isOpened = ref(false);
const expanded = computed(() => (isOpened.value || props.isOpen));

const parentIcon = computed(() => (
  isOpened.value ? props.parentIcon.open : props.parentIcon.close
));

function toggle() {
  if (props.isParent) {
    isOpened.value = !isOpened.value;
  }
}
</script>

<template>
  <li :class="{parent: isParent}">
    <div
      class="item clearfix"
      :class="{bold: isParent}"
      @click="toggle"
    >
      <div class="name">
        <slot name="acciones-extra"></slot>
        <slot name="parent-icon" :is-parent="isParent" :parent-icon="parentIcon">
          <i v-if="isParent" class="parent-icon" :class="parentIcon"></i>
        </slot>
        <slot name="name">
          {{ name }}
        </slot>
      </div>
      <div class="actions">
        <div
          class="btn-group pull-right"
          role="group"
        >
          <button
            v-show="showEditButton"
            type="button"
            class="btn btn-white btn-xs"
            @click.stop="emits('edit')"
          >
            <i class="fa fa-edit"></i>
          </button>
          <button
            v-show="showAddButton"
            type="button"
            class="btn btn-cifra btn-xs"
            @click.stop="emits('add')"
          >
            <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
    </div>
    <div v-show="subtitle && expanded" class="subtitle">
      {{ subtitle }}
    </div>
    <ul v-show="expanded" v-if="isParent">
      <slot></slot>
    </ul>
  </li>
</template>

<style lang="scss" scoped>
  ul {
    margin: 0;
    padding-left: 1.2em;
    list-style-type: none;
  }
  .bold {
    cursor: pointer;
    font-weight: 600;
  }
  .item {
    padding: 5px;
    border-radius: 3px;
    display: flex;

    &:hover {
      background-color: #f7f2f2;
    }
    .name {
      flex: 1;
    }
    .actions {
      white-space: nowrap;
    }
  }
  .subtitle {
    font-weight: normal;
  }
  .parent {
    list-style: none;
    font-size: 14px;
    border-bottom: 1px solid #f7f2f2;
  }
  .parent-icon {
    font-size: 20px;
    padding-right: 5px;
  }
</style>
